import { useQuery } from "@tanstack/react-query";

import { invoiceRecipientQueries } from "~/modules/billing/api/invoiceRecipient/invoiceRecipientQueries.ts";
import type { BillingSettingsLookupData } from "~/modules/billing/utils/billingSettingsDisplayUtils.ts";
import { clientContactPersonQueries } from "~/modules/client/api/clientContactPerson/clientContactPersonQueries.ts";
import { useAllCurrencies } from "~/modules/country/api/currency/currencyQueries.ts";


type UseBillingSettingsLookupsResult = BillingSettingsLookupData & {
	isLoading: boolean;
};

export function useBillingSettingsLookups(clientId: string): UseBillingSettingsLookupsResult {
	const { data: currencies, isLoading: currenciesIsLoading } = useAllCurrencies();

	const { data: invoiceRecipients, isLoading: invoiceRecipientsIsLoading } = useQuery(
		invoiceRecipientQueries.byClient(clientId),
	);

	const { data: clientContactPersons, isLoading: clientContactPersonsIsLoading } = useQuery(
		clientContactPersonQueries.all(),
	);

	return {
		currencies,
		invoiceRecipients,
		clientContactPersons,
		isLoading: invoiceRecipientsIsLoading || clientContactPersonsIsLoading || currenciesIsLoading,
	};
}